import type { ComponentMultiStyleConfig } from "@chakra-ui/react"

// .bns-modal: square, hairline border, overlay shadow; footer on surface-alt with a top border.
// 24px paddings (ADR 0001, lot 4: 40px felt enormous); the footer keeps its centred alignment.
export const Modal: ComponentMultiStyleConfig = {
  parts: ["overlay", "dialogContainer", "dialog", "header", "closeButton", "body", "footer"],
  baseStyle: {
    overlay: {
      bg: "rgba(0, 0, 0, 0.55)",
    },
    dialog: {
      borderRadius: "none",
      border: "1px solid",
      borderColor: "line",
      boxShadow: "overlay",
      bg: "surface",
      color: "text",
    },
    header: {
      fontSize: "xl",
      fontWeight: "light",
      lineHeight: "snug",
      color: "text",
    },
    closeButton: {
      color: "textMuted",
      _hover: {
        color: "accent",
        bg: "transparent",
      },
    },
    body: {
      pt: 6,
      pb: 6,
      px: 6,
    },
    footer: {
      px: 6,
      py: 5,
      display: "flex",
      justifyContent: "center",
      gap: 4,
      bg: "surfaceAlt",
      borderTop: "1px solid",
      borderTopColor: "line",
    },
  },
}
